export const ChargebackInformationNameFields = {
	reasonForReview: "reasonForReview",
	reductionPlan: "reductionPlan",
	reductionPlanDescription: "reductionPlanDescription",
	documentReview: "chargebackDocumentReview",
	followUpDate: "followUpDate",
	nextChargebackReviewDate: "nextChargebackReviewDate",
	assigneeId: "assigneeId",
};

export const ChargebackRecommendationNameFields = {
	recommendation: "recommendation",
	decision: "decision",
};
